module.exports = __webpack_public_path__ + "img/img-lung_leson_selection.0e71ea49.svg";